import { AssembleCanvas } from "@/components/AssembleCanvas";
import { buildBrain, BRAIN_TIMING } from "@/lib/brainScene";
import { useDelayedReveal } from "@/lib/useDelayedReveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";

export const CandidatiHero = () => {
  const on = useDelayedReveal(5000);
  return (
    <section className="hero-full relative w-full overflow-hidden" data-testid="candidati-hero-section">
      <AssembleCanvas dim={on} build={buildBrain} timing={BRAIN_TIMING} testId="candidati-hero-canvas" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(ellipse 55% 45% at center, rgba(5,5,5,0.5), rgba(5,5,5,0) 70%)", opacity: on ? 1 : 0, transition: "opacity 1.6s ease" }}
      />
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6" data-testid="candidati-hero-text" data-visible={on}>
        <div className={`scan-text ${on ? "is-on" : ""}`}>
          <Eyebrow className="mb-8">Per i Candidati</Eyebrow>
        </div>
        <h1
          className={`scan-text ${on ? "is-on" : ""} font-extrabold tracking-[-0.05em] leading-[0.95] text-5xl sm:text-7xl lg:text-8xl xl:text-[7.5rem] max-w-6xl`}
          style={{ transitionDelay: on ? "120ms" : "0ms" }}
          data-testid="candidati-hero-title"
        >
          Non sei un pezzo di carta.
        </h1>
        <p
          className={`scan-text ${on ? "is-on" : ""} mt-10 max-w-[720px] text-base sm:text-lg lg:text-xl leading-[1.85] text-titanium font-light`}
          style={{ transitionDelay: on ? "320ms" : "0ms" }}
          data-testid="candidati-hero-subtitle"
        >
          Il curriculum tradizionale è obsoleto. Le aziende non cercano una lista di esperienze passate, cercano la tua
          reale attitudine. Decodifica il tuo potenziale e lascia che il mercato del lavoro si adatti a te.
        </p>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-3 pointer-events-none">
        <span className="text-[10px] tracking-[0.35em] uppercase text-titanium">Scorri</span>
        <span className="h-8 w-[18px] rounded-full border border-[#2a2d33] flex justify-center pt-1.5">
          <span className="anim-scroll-dot h-1.5 w-1 rounded-full bg-[#00e5ff]" />
        </span>
      </div>
    </section>
  );
};
